import CloudDoneOutlinedIcon from '@mui/icons-material/CloudDoneOutlined';
import LanguageIcon from '@mui/icons-material/Language';
import LockOutlinedIcon from '@mui/icons-material/LockOutlined';
import MoveUpIcon from '@mui/icons-material/MoveUp';

import { DomainInfo200SetupProgress } from '@newfold/huapi-js/src/index.schemas';

import WordPressIcon from '~/scenes/Sites/assets/icons/WordPressIcon';

import {
  STEP_COLORS,
  STEP_ERRORS,
  STEP_KEYS,
  STEP_STATUSES,
} from './constants';

export function translateStatus(status?: number | null): string {
  if (status === null || status === undefined) return STEP_STATUSES.notstarted;
  else if ([1, 2].includes(status)) return STEP_STATUSES.completed;
  else if (!status) return STEP_STATUSES.active;
  else if (status < 0) return STEP_STATUSES.errored;
  return STEP_STATUSES.notstarted;
}

export function getIsActionableError(error?: string | null): boolean {
  return error
    ? [
        ...STEP_ERRORS.unrecoverable,
        ...STEP_ERRORS.retry,
        ...STEP_ERRORS.unregistered,
      ].includes(error)
    : false;
}

export function getIsStillInProgressError(
  setupProgress?: DomainInfo200SetupProgress,
): boolean {
  return setupProgress
    ? STEP_ERRORS.inprogress.includes(setupProgress.validate_dns_error!) ||
        STEP_ERRORS.inprogress.includes(setupProgress.validate_ssl_error!) ||
        STEP_ERRORS.inprogress.includes(setupProgress.validate_cdn_error!)
    : false;
}

export function getStepIconColor(stepStatus: string): string {
  switch (stepStatus) {
    case STEP_STATUSES.active:
      return STEP_COLORS.active;
    case STEP_STATUSES.completed:
      return STEP_COLORS.completed;
    case STEP_STATUSES.errored:
      return STEP_COLORS.errored;
    default:
      return STEP_COLORS.notStarted;
  }
}

// Return the icon for a step
export function getStepIcon(stepType: string, iconColor: string): JSX.Element {
  const iconFontSize = 'large';

  switch (stepType) {
    case STEP_KEYS.cdn:
      return (
        <CloudDoneOutlinedIcon
          data-testid={'cloud-icon'}
          fontSize={iconFontSize}
          sx={{ color: iconColor }}
        />
      );
    case STEP_KEYS.dns:
      return (
        <LanguageIcon
          data-testid={'language-icon'}
          fontSize={iconFontSize}
          sx={{ color: iconColor }}
        />
      );
    case STEP_KEYS.site:
      // The WP Icon (SvgIcon) doesn't seem to accept sx, so using this workaround
      const wpIconColorParts = iconColor.split('.main');
      return (
        <WordPressIcon
          data-testid={'wp-icon'}
          fontSize={iconFontSize}
          color={wpIconColorParts[0]}
        />
      );
    case STEP_KEYS.ssl:
      return (
        <LockOutlinedIcon
          data-testid={'lock-icon'}
          fontSize={iconFontSize}
          sx={{ color: iconColor }}
        />
      );
    case STEP_KEYS.url:
      return (
        <MoveUpIcon
          data-testid={'moveup-icon'}
          fontSize={iconFontSize}
          sx={{ color: iconColor }}
        />
      );
    default:
      return <></>;
  }
}
